import { render, staticRenderFns } from "./chartBlock.vue?vue&type=template&id=60f1b112"
import script from "./chartBlock.vue?vue&type=script&lang=js"
export * from "./chartBlock.vue?vue&type=script&lang=js"
import style0 from "./chartBlock.vue?vue&type=style&index=0&id=60f1b112&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports